import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Store } from '@ngrx/store';

import { Utente } from '../shared/models/utente.model';
import { AppState } from '../store/app.state';
import * as authActions from './store/auth.actions';
import { RoleType } from '../shared/models/role-type.model';
import { ResourceType } from '../shared/models/resource-type.model';
import { GlossaryType } from '../shared/models/glossary-type.model';
import { NoteType } from '../shared/models/note-type.model';
import { Observable } from 'rxjs';
import { AttachmentType } from '../shared/models/attachment-type.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  /**Timer di scadenza della key identificativa */
  private keyExpirationTimer:any;

  /**
   * Costruttore di AuthService
   * @param http {HttpCliente} per la gestione delle chiamate a BE
   * @param store {Store<AppState>} stato a livello dell'applicazione
   */
  constructor(
    private http: HttpClient,
    private store: Store<AppState>
  ) { }

  /**
   * Metodo per la chiamata a BE di login utente
   * @param username {string} nome utente
   * @param password {string} password utente
   */
  login(username: string, password: string) {
    return this.http.post<Utente>(
      'service/authentication/authenticate',
      {
        'username': username,
        'password': password
      }
    );
  }

  /**Metodo che gestisce la chiamata GET al BE che estende la durata della key di identificazione univoca */
  keepaliveKey() {
    return this.http.get<Object>('service/authentication/keepAlive');
  }

  /**Metodo che avvia il timer per la scadenza della key identificativa, alla scadenza lancia l'azione di logout */
  setLogoutTimer() {
    if(localStorage['loggedUser']) { //creo il timer solamente se sono loggato
      let expirationDate = new Date().valueOf() + 1800000;
      localStorage.setItem('expirationDate',expirationDate.toString());
      this.keyExpirationTimer = setTimeout(() => {
        this.store.dispatch(new authActions.ShowWarning(true));
      }, 1760000);
    }
  }

  /**Metodo che cancella e riporta a null il timer */
  clearLogoutTimer() {
    if(this.keyExpirationTimer) {
      clearTimeout(this.keyExpirationTimer);
      this.keyExpirationTimer = null;
    }
  }

  /**Metodo che esegue i metodi per il ripristino del timer in caso di chiamate a BE */
  refreshLogoutTimer() {
    this.clearLogoutTimer();
    this.setLogoutTimer();
  }


  // updatePW()
  // /**
  //  *  Metodo che gestisce la chiamata a BE per modificare un utente
  //  * @param utenteMod utente con le modifiche da memorizzare
  //  */
  // updatePW(utenteMod: Utente) {
  //   return this.http.post(
  //     'service/account/'+ utenteMod.id + '/update',
  //     utenteMod
  //   );
  // }
  /**Metodo che gestisce la chiamata a BE per il recupero dell'elenco di tipologie di profilo disponibili nell'applicazione */
  getTipiProfilo() {
    return this.http.get<RoleType[]>('service/account/types');
  }

  /**Metodo che gestisce la chiamata a BE per il recupero dell'elenco di tipologie di risorse */
  getTipiRisorsa() {
    return this.http.get<ResourceType[]>('service/resource/types');
  }

  /**Metodo che gestisce la chiamata a BE per il recupero dell'elenco di tipologie di glossari */
  getTipiGlossario() {
    return this.http.get<GlossaryType[]>('service/glossary/types');
  }

  /**Metodo che gestisce la chiamata GET per il recupero dell'elenco di tipologie di note */
  getTipiNota(): Observable<NoteType[]> {
    return this.http.get<NoteType[]>('service/note/types');
  }

  /**
   * Metodo che gestisce la chiamata a BE per il recupero delle note personali
   * @param idUtente {number} identificativo dell'utente loggato
   */
  getTemporary(idUtente: number){
    return this.http.get('service/account/' + idUtente + '/temporary', {responseType: "text"})
  }

  /**
   * Metodo che gestisce la chiamata a BE per il salvataggio di una nuova nota personale
   * @param idUtente {number} identificativo dell'utente loggato
   * @param newNote {string} nuovo html delle note personali
   */
  postTemporary(idUtente: number, newNote: string): Observable<any> {
    return this.http.post(
      'service/account/' + idUtente + '/temporary',
      newNote
    );
  }
  
  /**
   * Metodo che gestisce la chiamata GET per il recupero delle tipologie di allegati disponibili
   * @returns l'elenco dei tipi di allegato
   */
  getTipiAllegati(): Observable<AttachmentType[]> {
    return this.http.get<AttachmentType[]>('service/attachment/types');
  }
}
